var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M7.94407 10.7221L13.4996 17.6665L19.0552 10.7221",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M1 2.38889L1 24.6111C1 25.3782 1.62183 26 2.38889 26L24.6111 26C25.3782 26 26 25.3782 26 24.6111L26 2.38889C26 1.62183 25.3782 1 24.6111 1L2.38889 1C1.62183 1 1 1.62183 1 2.38889Z",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrow);
export default __webpack_public_path__ + "static/media/expandArrow.f3ab4a49d9dc34c6d5ddae8a7d5596d6.svg";
export { ForwardRef as ReactComponent };